/**
 * @fileoverview hook to manage the media library tags
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { mediaLibraryTagsCacheKey } from "./constants";
import type { MediaLibraryTagsParams, MediaLibraryTagsResult } from "./types";
import { isMediaLibraryTagsResult } from "./validators";

/**
 * fetch tags for media library associated to a single app group from backend
 *
 * @param appGroupId - the current app group
 *
 * @returns the data from the fetch in a promise
 */
export const getMediaLibraryTags = reactQueryFetcherAdapter(
  mediaLibraryTagsCacheKey,
  (signal: AbortSignal, { appGroupId }: MediaLibraryTagsParams): Promise<MediaLibraryTagsResult> => {
    return fetch(
      `/engagement/${appGroupId}/media_library_tags`,
      "GET",
      {
        app_group_id: appGroupId,
      },
      { signal }
    );
  },
  isMediaLibraryTagsResult
);
